import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, Tooltip } from "@mui/material";
import React, { useState } from "react";

import styles from "../ProfilePage.module.scss";

interface NewApiKeyBannerProps {
  apiKey: string;
  onClose: () => void;
}

const NewApiKeyBanner: React.FC<NewApiKeyBannerProps> = ({
  apiKey,
  onClose,
}) => {
  const [copied, setCopied] = useState(false);

  return (
    <div className={styles.developerNewKey}>
      <div className={styles.developerNewKeyHeader}>
        <span className={styles.developerNewKeyLabel}>
          Your new API key — copy it now, it won&apos;t be shown again.
        </span>
        <IconButton
          size="small"
          onClick={onClose}
          sx={{ color: "#9d9d9d", padding: "2px" }}
        >
          <CloseIcon sx={{ fontSize: 14 }} />
        </IconButton>
      </div>
      <div className={styles.developerNewKeyRow}>
        <span className={styles.developerKeyValue}>{apiKey}</span>
        <Tooltip title={copied ? "Copied!" : "Copy"}>
          <IconButton
            size="small"
            onClick={() => {
              navigator.clipboard.writeText(apiKey);
              setCopied(true);
              setTimeout(() => setCopied(false), 2000);
            }}
            sx={{
              color: copied ? "#54dd79" : "#b6b6b6",
              flexShrink: 0,
            }}
          >
            {copied ? (
              <CheckCircleIcon sx={{ fontSize: 14 }} />
            ) : (
              <ContentCopyIcon sx={{ fontSize: 14 }} />
            )}
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
};

export default NewApiKeyBanner;
